import buildLinkElementFromFieldsValuesHelper from '../../../common/components/link-field/helpers/build-link-element-from-fields-values';
import linkAttributes from '../../../common/constants/link-attributes';
import { linkFieldNames } from '../constants/field-names';

const buildLinkElementFromFieldsValues = (fieldsValues) => {
  const clickActionEnabled = fieldsValues[linkFieldNames.LINK_CLICK_ACTION];

  if (!clickActionEnabled) {
    return null;
  }

  const linkElement = buildLinkElementFromFieldsValuesHelper(fieldsValues);

  if (linkElement) {
    linkElement.classList.add(linkAttributes.CLICK_ACTION_LINK_CLASS);
  }

  return linkElement;
};

export default buildLinkElementFromFieldsValues;
